<template>
  <div class="app">
    <header class="clearfix" v-cloak >
      <a v-if="ifylxd" @click="showrecore" href="javascript:;"></a>
    </header>
    <section class="card-box">
        <participate :cardActivityNo="cardActivityNo"></participate>
        <Carddisplay 
                  :carddata="carddata"
                  :carno="carno"
                  :hchengka="hchengka"
                  :synthesis="synthesis"
                  :activityTimes="activityTimes"
                  :cardnolistmy="cardnolistmy"
                  :juanlink="juanlink"
                  :yifenlink="yifenlink"
                  :jinliif="jinliif"
                  :jinlilink="jinlilink"
                  :classstay="classstay"
                  :ifylxd="ifylxd"
        ></Carddisplay>
        <strategy :ifylxd="ifylxd"></strategy>
        <speed :ifylxd="ifylxd"></speed>
        <rules></rules>
    </section>
    <kalayer v-if="kabox" :ifprizekapiandata="ifprizekapiandata"
    :prizekapiandata="prizekapiandata"
    :hchengkadaka="hchengkadaka"
    :jinlilink="jinlilink"
    :yifenlink="yifenlink"
    ></kalayer>
    <rewardlayer v-if="awardbox" :jianglianj="jianglianj" 
                                 :jiangliadata="jiangliadata" 
                                 :saletanpgno="saletanpgno" 
                                 :juanlink="juanlink"
    ></rewardlayer>
    <pick v-if="pickif"></pick>
    <record v-show="recordif" :recordif="recordif" :ifylxd="ifylxd" :cardnolist="cardnolist" :cardActivityNo='cardActivityNo'></record>
    <clan v-if="clanif"></clan>
  </div>
</template>

<script>
import * as url from '../../assets/js/url';
import participate from '../commont/participate';
import rules from '../commont/rules';
import strategy from '../commont/strategy';
import speed from '../commont/speed';
import Carddisplay from '../commont/Carddisplay'
import kalayer from '../commont/kalayer'
import rewardlayer from '../commont/rewardlayer'
import pick from '../commont/pick'
import record from '../commont/record'
import clan from '../commont/clan'
export default {
    data () {
      return {
        alertState:false,
        alertData:'',
        minAlertState:false,//小程序弹框状态
        test:'',
        parnum:'200',
        cardnolistarr:{
            ule:{
                "cd_209":{totalNums:0,ifget:1,inde:15,taget:-1,hcif:true},//合成卡
                "cd_210":{totalNums:0,ifget:1,inde:14,taget:-1,hcif:true},//锦鲤卡
                "cd_211":{totalNums:0,ifget:1,inde:13,taget:-1,hcif:true},//万能卡
                "cd_212":{totalNums:0,ifget:1,inde:1,taget:-1,hcif:true},//鼠
                "cd_213":{totalNums:0,ifget:1,inde:2,taget:-1,hcif:true},// 	牛
                "cd_214":{totalNums:0,ifget:1,inde:3,taget:-1,hcif:true},// 虎
                "cd_215":{totalNums:0,ifget:1,inde:4,taget:-1,hcif:true},// 	兔
                "cd_216":{totalNums:0,ifget:1,inde:5,taget:-1,hcif:true}, // 龙
                "cd_217":{totalNums:0,ifget:1,inde:6,taget:-1,hcif:true},// 	蛇
                "cd_218":{totalNums:0,ifget:1,inde:7,taget:-1,hcif:true},// 	马
                "cd_219":{totalNums:0,ifget:1,inde:8,taget:-1,hcif:true},// 	羊
                "cd_220":{totalNums:0,ifget:1,inde:9,taget:-1,hcif:true}, // 候
                "cd_221":{totalNums:0,ifget:1,inde:10,taget:-1,hcif:true},// 鸡
                "cd_222":{totalNums:0,ifget:1,inde:11,taget:-1,hcif:true},// 狗
                "cd_223":{totalNums:0,ifget:1,inde:12,taget:-1,hcif:true},// 猪
            },
            ylxd:{ //生产正式
                "cd_193":{totalNums:0,ifget:1,inde:15,taget:-1,hcif:true},//合成卡
                "cd_194":{totalNums:0,ifget:1,inde:14,taget:-1,hcif:true},//锦鲤卡
                "cd_195":{totalNums:0,ifget:1,inde:13,taget:-1,hcif:true},//万能卡
                "cd_197":{totalNums:0,ifget:1,inde:1,taget:-1,hcif:true},//鼠
                "cd_198":{totalNums:0,ifget:1,inde:2,taget:-1,hcif:true},//牛
                "cd_199":{totalNums:0,ifget:1,inde:3,taget:-1,hcif:true},// 虎
                "cd_200":{totalNums:0,ifget:1,inde:4,taget:-1,hcif:true},// 兔
                "cd_201":{totalNums:0,ifget:1,inde:5,taget:-1,hcif:true}, //龙
                "cd_202":{totalNums:0,ifget:1,inde:6,taget:-1,hcif:true},//蛇
                "cd_203":{totalNums:0,ifget:1,inde:7,taget:-1,hcif:true},// 马
                "cd_204":{totalNums:0,ifget:1,inde:8,taget:-1,hcif:true},// 羊
                "cd_205":{totalNums:0,ifget:1,inde:9,taget:-1,hcif:true}, // 候
                "cd_206":{totalNums:0,ifget:1,inde:10,taget:-1,hcif:true},// 鸡
                "cd_207":{totalNums:0,ifget:1,inde:11,taget:-1,hcif:true},// 狗
                "cd_208":{totalNums:0,ifget:1,inde:12,taget:-1,hcif:true},// 猪
            }
        },//卡片批次号
        cardnolist:{},
        cardnolistmy:{},
        hcehngcadarr:{
                   ule:'cd_209',
                   ylxd:'cd_193'
                },//h合成卡卡号
        hcehngcad:'cd_209',//h合成卡卡号
        jinlikas:{
            ule:'cd_210',
            ylxd:'cd_194'
        },
        jinlika:'cd_210',
        wangnengs:{
            ule:'cd_211',
            ylxd:'cd_195'
        },
        wangneng:'cd_211',
        yifenlinks:{
                    ule:'//www.ule.com/event/tmpl/ulewap.html?actId=830',
                    ylxd:'//www.ule.com/event/tmpl/uxdwap.html?actId=829'
                },
        yifenlink:'//www.ule.com/event/tmpl/ulewap.html?actId=830',
        jinlilinks:{
                    ule:'//www.ule.com/event/tmpl/ulewap.html?actId=831',
                    ylxd:'//www.ule.com/event/tmpl/uxdwap.html?actId=828'
                },
        jinlilink:'//www.ule.com/event/tmpl/ulewap.html?actId=831',
        cardActivityarr:{
            ule:'CARD_1577788631093',
            ylxd:'CARD_1577787542685',
        },
        cardActivityNo:'CARD_1577788631093',//集卡活动code默认大网
        ifylxd:false,          
        activityCodearr:{
            ule:'MA_U_157778398710117',
            ylxd:'MA_U_157708256103074'
        },
        activityCode:'MA_U_157778398710117',//领卡code默认大网
        activityTimes:0,// 抽卡次数
        synthesis:false,////是否可以合成  
        ruleCode:'',//合成卡片活动规则  
        hchengka:false,//卡中是否有合成卡
        carddata:{},//大卡数据     
        carno:false,//用户是否是没有卡   
        juanlink:'',//卷列表链接 
        kabox:false,//卡片弹框判断
        ifprizekapiandata:false,//是否抽到祝福卡
        prizekapiandata:{},//抽卡时数据
        hchengkadaka:false,//是否是抽合成卡
        firstClickTimes:"",//控制连点出发抽卡事件
        jianglianj:false,//判断是否是奖励金
        swiactiveIndex:'0',//轮播图下标
        jiangliadata:{},//奖励数据
        awardbox:false,//奖励弹框显示
        jinliif:false,//是否有锦鲤卡
        wangnengif:false,//是否有万能卡
        saletanpgno:false,//是否有奖
        recordif:false,//赠卡纪录
        classstay:false,//小卡滑动样式
        pickif:false,//战队成员显示
        zengsongcardNo:'',//赠送的卡片号
        clanif:false,
      }
    },
    created(){
      let m=this;
        if(this.BASE.$browser().ylxd){
          let script = document.createElement("script");
          script.type = "text/javascript";
          script.src = "//i0.ulecdn.com/app/yxd/j/yl/dsbridge.js";
          document.getElementsByTagName("head")[0].appendChild(script);
          m.ifylxd=true;
          this.cardnolist=this.cardnolistarr.ylxd;
          this.hcehngcad=this.hcehngcadarr.ylxd;
          this.yifenlink=this.yifenlinks.ylxd;
          this.jinlilink=this.jinlilinks.ylxd;
          this.cardActivityNo=this.cardActivityarr.ylxd;
          this.activityCode=this.activityCodearr.ylxd;
          this.jinlika=this.jinlikas.ylxd;
          this.wangneng=this.wangnengs.ylxd;
          window.addEventListener('pageshow',function(){
              dsBridge.call("setNativeTitle", {
                  "title": "集卡赢一分购特权"
              })
          },false);
        }else{
          this.cardnolist=this.cardnolistarr.ule;
        }
        // JEND.getStatus.isLogin(function () {
                m.takeBoxfun();
                m.cardsnum();
                m.userCardfun();
        // })
        this.juanlink=m.getMyCouponUrl();
               
    },
    methods:{
      takeBoxfun(){//查询用户抽卡次数
        let m=this;
        this.HTTP.takeBoxs(m.activityCode).then((res) => {
            if(res.body.code=='0000'){
              m.activityTimes=res.body.content[0].times||0;
            }
        }, (err) => {
            console.log(err);
        });
      },
      cardsnum(){//获取用户卡片数量是否合成
        let m=this,taget=0;
        this.HTTP.cardsnumhttp(m.cardActivityNo).then((res) => {
           if(res.body.code=='0000'){
                                let cardInfos=res.body.content.cardInfos,hcif=false,arrdata={};
                                let arrdatamy=JSON.stringify(m.cardnolist)
                                arrdata=JSON.parse(arrdatamy);
                                for(var i=0;i<cardInfos.length;i++){
                                    if(cardInfos[i].totalNums>0){
                                        arrdata[cardInfos[i].cardNo].totalNums=cardInfos[i].totalNums;
                                        arrdata[cardInfos[i].cardNo].ifget='2';
                                        arrdata[cardInfos[i].cardNo].status="";
                                        arrdata[cardInfos[i].cardNo].taget=taget;
                                        taget += cardInfos[i].totalNums;
                                        if(cardInfos[i].cardNo==m.hcehngcad&&cardInfos[i].totalNums>0){
                                            hcif=true;
                                            m.hchengka=true;
                                            m.classstay=true;
                                        }
                                        if(cardInfos[i].cardNo==m.jinlika){
                                            m.jinliif=true;
                                            m.classstay=true;
                                        }
                                        if(cardInfos[i].cardNo==m.wangneng){
                                            m.wangnengif=true;
                                            m.classstay=true;
                                        }
                                    }else{
                                        arrdata[cardInfos[i].cardNo].totalNums=cardInfos[i].totalNums;
                                        arrdata[cardInfos[i].cardNo].ifget='1';
                                        arrdata[cardInfos[i].cardNo].status="over";
                                        arrdata[cardInfos[i].cardNo].taget=taget;
                                        taget += cardInfos[i].totalNums;
                                    }

                                }
                                if(res.body.content.combineChances[0].combineFlag==1){
                                    m.synthesis=true;
                                }
                                m.ruleCode=res.body.content.combineChances[0].ruleCode;
                                m.cardnolist[m.hcehngcad].hcif=hcif;
                                arrdata[m.hcehngcad].hcif=hcif;
                                if(!m.hchengka){
                                  delete arrdata[m.hcehngcad];
                                }else{
                                  m.timetipfun(true);
                                }
                                if(!m.jinliif){
                                    delete arrdata[m.jinlika];
                                }else{
                                  m.timetipfun(false);
                                }
                                if(!m.wangnengif){
                                    delete arrdata[m.wangneng];
                                }

                                m.cardnolistmy=arrdata;
                            }
        }, (err) => {
            // console.log(err);
        });
      },
      userCardfun(){//获取用户大卡
        let m=this;
        this.HTTP.userCardhttp(m.cardActivityNo).then((res) => {
           let obj=res.body;
           if(obj.code=='0000'){
                                if(obj.content.length>0){
                                    for(var i=0;i<obj.content.length;i++){
                                        obj.content[i].indexka=m.cardnolist[obj.content[i].cardNo].inde;
                                        obj.content[i].class="p"+m.cardnolist[obj.content[i].cardNo].inde;
                                    }
                                    if($('.car-large .js-carno')){
                                        $('.car-large .js-carno').css({"display":"none"})
                                    }
                                    m.carddata=obj.content;
                                     m.carno=false;
                                }else{
                                    m.carno=true;
                                }
                            }else{
                                m.carno=true;
                            };
        }, (err) => {
            m.carno=true;
        });
      },
      // 获取我的优惠券链接
      getMyCouponUrl() {
                    if ($.browser.ule) {
                        // 邮乐APP里
                        if ($.browser.android) {
                            return encodeURI('ULEMOBILE://action_ShoppingActivity#wgt.CouponList');
                        } else{
                            return encodeURI('ulemobile://uleCommon_viewname$$CouponViewController^^xib$$0^^isHideTab$$1');
                        }
                    } else if ($.browser.ylxd) {
                        // 小店APP里
                        if ($.browser.android) {
                            return encodeURI('ulemobile://action&&ui.MyCouponActivity##fragment::1**flag::0**title::优惠券**needTitle::true');
                        } else{
                            return encodeURI('ulemobile://action&&US_CouponVC&hasxib|0');
                        }
                    } else {
                        // 其他场景
                        return '//m.ule.com/muser/coupon/list';
                    }
      },
      // 获取卡片 
      getka(){
        let m=this;
        let dataTime = new Date();
        if(m.firstClickTimes==""||dataTime-m.firstClickTimes>=2000){
            m.firstClickTimes=dataTime;
            this.HTTP.lottryhttp(m.activityCode).then((res) => {
                m.kabox=true;
                if(res.body.code=='0000'){
                m.hchengkadaka=false;
                m.ifprizekapiandata=false;
                let kadata=res.body.content.prizeInfos[0];
                console.log(kadata);
                 kadata.indexpk=m.cardnolist[kadata.pcBatchId].inde;
                 kadata.class="p"+m.cardnolist[kadata.pcBatchId].inde;
                  m.prizekapiandata=kadata;
                 m.cardsnum();//获取用户卡片数量是否合成
                 m.userCardfun();//获取用户大卡
             }else{
                m.ifprizekapiandata=true;
             }
                m.takeBoxfun();//查询用户抽卡次数
            }, (err) => {
                m.kabox=true;
                m.ifprizekapiandata=true;
            });
        }
    
      },
      // 合成卡片
      hccombine(){
        let m=this;
        this.HTTP.combinehttp(m.cardActivityNo,m.ruleCode).then((res) => {
           
              if(res.body){
                                console.log(res.body);
                                if(res.body.code=='0000'){
                                    m.hchengkadaka=true;
                                    m.kabox=true;
                                    m.ifprizekapiandata=false;
                                    m.prizekapiandata.pcBatchId=res.body.content[0].cardNo;
                                    m.prizekapiandata.indexpk=m.cardnolist[res.body.content[0].cardNo].inde;
                                    m.prizekapiandata.class='p'+m.cardnolist[res.body.content[0].cardNo].inde;
                                    m.cardsnum();//获取用户卡片数量是否合成
                                    m.userCardfun();//获取用户大卡
                                }
                            }
    
        }, (err) => {
            console.log(err);
        });
      },
      // 翻卡抽奖
      takeBox(activityCode,channelka){
        let m=this;
        this.HTTP.turnOverTheCardhttp(m.cardActivityNo,activityCode,channelka).then((res) => {
            console.log(res)
            m.awardbox=true;
           if(res.body){
                m.kabox=false;
                if(res.body.code=='0000'){
                    m.saletanpgno=false;
                    //成功调取
                    let prizeInfos=res.body.content.prizeInfos[0];
                    if(prizeInfos.prizeType=='40600'||prizeInfos.prizeType=='50502'||prizeInfos.prizeType=='40200'||prizeInfos.prizeType=='40300'){
                        m.jianglianj=true;
                    }else {
                        m.jianglianj=false;
                    }
                    m.jiangliadata=prizeInfos;
                    m.userCardfun();//获取用户大卡
                }else{
                    m.saletanpgno=true;
                }
            }else {
                m.saletanpgno=true;
            }

        }, (err) => {
            m.saletanpgno=true;
        });
      },
      shouxiaokapicha(nu){
                    var m=this;
                    if(nu==1){
                        m.kabox=false;
                    }else if(nu==2){
                        m.awardbox=false;
                    }else if(nu==3){
                        m.pickif=false;
                    }else if(nu==4){
                        m.clanif=false;
                    }else if(nu==5){
                        m.recordif=false;
                    }
      },
      showrecore(){
      let m=this;
      m.recordif=true;
      },
    // 查询战队成员
      qrygivefunct(cardId){
        let m=this;
        m.pickif=true;
        m.zengsongcardNo=cardId;
      },
      timetipfun(hc){//时间判断出弹层
        let m=this;
        this.HTTP.datetime().then((res) => { 
                let times=res.time;
                var statdata1=new Date().parse("2020-02-10 18:00:00").getTime();
                var statdata2=new Date().parse("2020-02-10 20:10:00").getTime();
                var enddata1=new Date().parse("2020-02-10 20:00:00").getTime();
                var enddata2=new Date().parse("2020-02-10 20:30:00").getTime();
                if(times>=statdata1&&times<=enddata1&&hc){
                    m.kabox=true;
                    m.ifprizekapiandata=false;
                    m.prizekapiandata={
                      indexpk:'15',
                    }
                     m.hchengkadaka=true;
                }else if(times>=statdata2&&times<=enddata2&&!hc){
                   m.hchengkadaka=false;
                    m.kabox=true;
                    m.ifprizekapiandata=false;
                    m.prizekapiandata={
                      indexpk:'14',
                    }
                }
        },(ree) =>{

        });
      },
      givefun(ownerId){//赠送卡片
        let m=this;
        this.HTTP.exChangeCardshttp(m.zengsongcardNo,ownerId,m.cardActivityNo).then((res) => { 
               if(res.body.returnCode=='0000'){
                 m.pickif=false;
                 JEND.tipBox('赠送成功');
                 m.cardsnum();//获取用户卡片数量是否合成
                 m.userCardfun();//获取用户大卡
               }else{
                JEND.tipBox('赠送失败，请稍后重试！');
               }
        },(ree) =>{
              JEND.tipBox('赠送失败，请稍后重试！');
        });
      },
      showclan(){
        let m=this;
        m.clanif=true;
      }
    },
    components:{
      participate,
      rules,
      strategy,
      speed,
      Carddisplay,
      kalayer,
      rewardlayer,
      pick,
      record,
      clan
    }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .swiper-inner {
    width: 100%;
    height: 400px;
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 300px;
    height: 300px;
  }
.app{
   background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/jbg.png) no-repeat top center #B51323;
   background-size: 100% 13.34rem;
   height: auto;
}
html body {
    background:#B51323;
    height: auto;
}
header {
    display: block;
    width: 100%;
    position: relative;
    overflow: hidden;
    height: 3.92rem;
}
header a {
    display: block;
    float: left;
    width: .46rem;
    height: 1.56rem;
    position: absolute;
    right: 0;
    top: 0.3rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/an3.png) no-repeat center;
    background-size: 100% 100%;
}
.card-box{
    display: block;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/two.vue